import { PropsWithChildren } from 'react';
import TeamsAuthProvider from './TeamsAuthProvider';
import FronteggAuthProvider from './FronteggAuthProvider';
import { AppType } from '@common/ui/Authenticated/interfaces.ts';
import { BackstageAuthProvider } from './BackstageAuthProvider';

export function Authenticated({ children }: PropsWithChildren) {
  switch (import.meta.env.VITE_APP_TARGET) {
    case AppType.Teams:
      return <TeamsAuthProvider>{children}</TeamsAuthProvider>;
    case AppType.Backstage:
      return <BackstageAuthProvider>{children}</BackstageAuthProvider>;
    default:
      return <FronteggAuthProvider>{children}</FronteggAuthProvider>;
  }
}
